import React from 'react';

export const MSIcon = React.memo(() => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.01072 0.474121H0V9.48484H9.01072V0.474121Z" fill="#F26522" />
    <path d="M18.956 0.474121H9.94531V9.48484H18.956V0.474121Z" fill="#8DC63F" />
    <path d="M9.01072 10.4194H0V19.4302H9.01072V10.4194Z" fill="#00AEEF" />
    <path d="M18.956 10.4194H9.94531V19.4302H18.956V10.4194Z" fill="#FFC20E" />
  </svg>
));
